import { alpha } from "@material-ui/core/styles";

const appWrapperStyle = theme => ({
  headerPapper: {
    width: "200px",
    height: "40px",
    backgroundColor: "#6d7278"
  },
  headerStyle: {
    boxShadow: "0 1px 2px 0 rgba(0,0,0,0.5)",
    zIndex: 3
  },
  appBarRoot: {
    backgroundColor: "#b5c0d2"
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha("#6d7278", 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing(2),
    marginLeft: 10,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto"
    }
  },
  searchIcon: {
    width: theme.spacing(7),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputRoot: {
    color: "inherit"
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: 200
    }
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex"
    }
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none"
    }
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalBody: {
    height: 267,
    width: 432,
    border: "3px solid #4D4D4D",
    borderRadius: 21,
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    outline: "none"
  },
  modalText: {
    color: "#02001A",
    fontSize: 28,
    fontWeight: "bold",
    lineHeight: "34px",
    textAlign: "center",
    width: 331,
    marginTop: 43,
    marginLeft: 51
  },
  modalActionContainer: {
    display: "flex",
    flex: 1,
    marginTop: 59,
    marginLeft: 41
  },
  trueButton: {
    height: 56,
    width: 163,
    borderRadius: 5,
    backgroundColor: "rgba(225,41,41,0.6)",
    color: "rgba(0,0,0,0.87)",
    fontSize: 20,
    lineHeight: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    outline: "none"
  },
  falseButton: {
    height: 56,
    width: 161,
    border: "1px solid #979797",
    borderRadius: 5,
    color: "rgba(0,0,0,0.87)",
    fontSize: 20,
    lineHeight: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 26,
    cursor: "pointer",
    outline: "none"
  },
  standardWarning: {
    backgroundColor: "#00AD50",
    color: "#FFFFFF",
    fontFamily: "Proxima Nova",
    fontSize: "18px",
    fontWeight: "600",
    letterSpacing: 0,
    lineHeight: "22px",
    textAlign: "center",
  }
});

export default appWrapperStyle;
